import { render, staticRenderFns } from "./Tenders.vue?vue&type=template&id=2ad759b3&scoped=true"
import script from "./Tenders.vue?vue&type=script&lang=js"
export * from "./Tenders.vue?vue&type=script&lang=js"
import style0 from "./Tenders.vue?vue&type=style&index=0&id=2ad759b3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ad759b3",
  null
  
)

export default component.exports